/**
 * Curated SMS Message Presets Library for Elite Poker Lounge (McAllen, Texas)
 */

export const SMS_PRESET_CATEGORIES = [
  { id: 'all', label: 'All Presets', icon: '🌟' },
  { id: 'short', label: '160-Char (1 Segment)', icon: '⚡' },
  { id: 'tournament', label: 'Tournaments', icon: '🏆' },
  { id: 'cash_game', label: 'Cash Games', icon: '♠️' },
  { id: 'hospitality', label: 'Food & Drinks', icon: '🍸' },
  { id: 'notice', label: 'Club Notices', icon: '📢' },
  { id: 'custom', label: 'Custom Saved', icon: '💾' },
];

export const CURATED_SMS_PRESETS = [
  // ⚡ SHORT & PUNCHY (160 CHARS / 1 SEGMENT) - Cuts carrier fees to a single segment & ensures 10DLC delivery
  {
    id: 'short_tourney_alert',
    title: 'Quick Tournament Tonight',
    category: 'short',
    tags: ['tournament', 'short', 'quick', 'evening'],
    body: `EPL: Featured Club Tournament starts tonight at 6 PM! Structure & details: elitepokerlounge.com/events. Call (956) 899-8888 to reserve. Reply STOP to opt out.`,
  },
  {
    id: 'short_cash_action',
    title: 'Quick Tables Open Now',
    category: 'short',
    tags: ['tables', 'short', 'live', 'seating'],
    body: `EPL: Live tables and seating open now! Chef kitchen & cocktails served table-side. Visit Elite Poker Lounge McAllen. Call (956) 899-8888. Reply STOP to opt out.`,
  },
  {
    id: 'short_weekend_kickoff',
    title: 'Quick Weekend Action',
    category: 'short',
    tags: ['weekend', 'friday', 'action', 'short'],
    body: `EPL Weekend: Evening action starts at 5 PM! Live tables & late-night kitchen at Elite Poker Lounge McAllen. Reserve: (956) 899-8888. Reply STOP to opt out.`,
  },
  {
    id: 'short_bad_beat_flash',
    title: 'High-Hand Celebration Alert',
    category: 'short',
    tags: ['celebration', 'high hand', 'short', 'event'],
    body: `EPL Alert: Club Milestone & High-Hand Celebration underway! Live tables open now at Elite Poker Lounge McAllen. Call (956) 899-8888. Reply STOP to opt out.`,
  },

  // 🏆 TOURNAMENTS
  {
    id: 'tourney_monthly_classic',
    title: 'Monthly Classic Championship Kickoff',
    category: 'tournament',
    tags: ['tournament', 'classic', 'championship', 'monthly'],
    body: `EPL: Cards, cocktails, dining, and a great crowd — starting today at 6 PM.

Join us for our Monthly Classic Championship tonight!

View event structure & details: https://elitepokerlounge.com/tournaments

Msg & data rates may apply. Reply STOP to opt out, HELP for help.`,
  },
  {
    id: 'tourney_sunday_bounty',
    title: 'Sunday Knockout Bounty',
    category: 'tournament',
    tags: ['tournament', 'bounty', 'sunday', 'knockout'],
    body: `EPL Sunday Knockout: Player Bounty Tournament today at 3:00 PM! 

Late registration open until 5:30 PM. Call (956) 899-8888 or visit front desk to reserve your seat.

Event details: elitepokerlounge.com/events. Reply STOP to opt out.`,
  },
  {
    id: 'tourney_deepstack_champ',
    title: 'Deepstack Championship',
    category: 'tournament',
    tags: ['tournament', 'deepstack', 'championship', 'saturday'],
    body: `EPL Deepstack Championship starts tonight at 7:00 PM! 

30,000 starting stack with 20-minute levels. Full dinner menu served table-side throughout play.

Elite Poker Lounge McAllen. Call (956) 899-8888. Reply STOP to opt out.`,
  },
  {
    id: 'tourney_member_freeroll',
    title: 'Weekly Members Appreciation Event',
    category: 'tournament',
    tags: ['tournament', 'member', 'appreciation', 'thursday'],
    body: `EPL Members Appreciation Event kicks off this Thursday at 6:30 PM! 

Complimentary entry for all active club members. Arrive early to lock in your seat.

Details: elitepokerlounge.com/events. Reply STOP to opt out.`,
  },

  // ♠️ LIVE TABLES & SEATING
  {
    id: 'cash_nlh_plo_active',
    title: 'Live Tables & Open Seating',
    category: 'cash_game',
    tags: ['tables', 'live', 'running', 'seating'],
    body: `EPL Club Update: Live tables and open seating are underway now!

Full bar & chef-prepared kitchen open. Stop in or call (956) 899-8888 to get on the table list.

Reply STOP to opt out.`,
  },
  {
    id: 'cash_early_bird_bonus',
    title: 'Early Bird Member Perk',
    category: 'cash_game',
    tags: ['early bird', 'perk', 'member'],
    body: `EPL Early Bird Perk: Check in to the club before 5:00 PM today to receive our member welcome bonus! 

Great food, cold drinks, and evening action at Elite Poker Lounge McAllen.

Reply STOP to opt out.`,
  },
  {
    id: 'cash_high_hand_frenzy',
    title: 'High-Hand Celebration Hourly',
    category: 'cash_game',
    tags: ['high hand', 'celebration', 'hourly'],
    body: `EPL High-Hand Celebration tonight! 

Hourly member recognition from 7:00 PM to 11:00 PM across all active tables. View details: elitepokerlounge.com/events.

Come grab a seat! Reply STOP to opt out.`,
  },

  // 🍸 FOOD, COCKTAILS & HOSPITALITY
  {
    id: 'hosp_late_night_kitchen',
    title: 'Late-Night Kitchen & Table-Side Cocktails',
    category: 'hospitality',
    tags: ['food', 'drinks', 'cocktails', 'kitchen', 'late night'],
    body: `EPL Late Night: Full kitchen and premium craft cocktails served table-side while you play! 

Tables running late into the morning. Come hungry and enjoy your evening at Elite Poker Lounge McAllen.

Reply STOP to opt out.`,
  },
  {
    id: 'hosp_weekend_party',
    title: 'Weekend Poker & Lounge Experience',
    category: 'hospitality',
    tags: ['weekend', 'party', 'drinks', 'action'],
    body: `The weekend starts at Elite Poker Lounge! 

Cold drinks, chef specials, live tables, and the best crowd in the RGV. Doors open now. Call (956) 899-8888.

Reply STOP to opt out.`,
  },

  // 📢 CLUB NOTICES & SPECIAL HOURS
  {
    id: 'notice_special_hours',
    title: 'Holiday / Special Club Hours',
    category: 'notice',
    tags: ['notice', 'hours', 'holiday', 'schedule'],
    body: `EPL Club Update: Elite Poker Lounge will be operating on special hours today, opening at 2:00 PM. 

Live tables and event action will run all evening. See you at the club!

Reply STOP to opt out.`,
  },
  {
    id: 'notice_vip_tables',
    title: 'VIP Private Table Booking',
    category: 'notice',
    tags: ['notice', 'vip', 'private', 'tables'],
    body: `EPL Notice: Private VIP tables and event pre-registration are open for this upcoming weekend. 

Contact club management at (956) 899-8888 or visit the front desk to reserve.

Reply STOP to opt out.`,
  },
];
